import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    let params = utils.merge(example, utils.initPageableParams(pageable));
    return httpService.get("/flow", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/flowService.js